import React from 'react'
import { Link, Container, styled } from '@mui/material'
import config from '../../config'

const PREFIX = 'AppStoreButton'

const classes = {
  downloadApp: `${PREFIX}-downloadApp`,
}

const styles = ({ theme }) => ({
  [`& .${classes.downloadApp}`]: {
    width: '46%',
    height: 'initial',
    cursor: 'pointer',
    [theme.breakpoints.up('md')]: {
      width: '40%',
    },
    [theme.breakpoints.up('lg')]: {
      width: '35%',
    },
  },
})

const StyledContainer = styled(Container)(styles)

function AppStoreButton() {
  return (
    <StyledContainer disableGutters>
      <Link
        target="_blank"
        href="https://apps.apple.com/sg/app/m1-prepaid/id1312731685"
        rel="noopener"
        sx={{ mr: '10px' }}
      >
        <img
          className={classes.downloadApp}
          src={`${config.PUBLIC_URL}/appstore.png`}
          alt="ios"
        />
      </Link>
      <Link
        target="_blank"
        href="https://play.google.com/store/apps/details?id=hms.custom.m1.prepaidPortal"
        rel="noopener"
      >
        <img
          className={classes.downloadApp}
          src={`${config.PUBLIC_URL}/googleplay.png`}
          alt="android"
        />
      </Link>
    </StyledContainer>
  )
}

export default AppStoreButton
